/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ volumeText: NonNullable<unknown>, range: NonNullable<unknown> }} Wrapped_Share_VolumeInputs */

const en_us2_wrapped_share_volume = /** @type {(inputs: Wrapped_Share_VolumeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.volumeText} lifted in the week of ${i?.range}. My Pocket Gym.`)
};

const pt_br2_wrapped_share_volume = /** @type {(inputs: Wrapped_Share_VolumeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.volumeText} levantadas na semana de ${i?.range}. My Pocket Gym.`)
};

const es_419_wrapped_share_volume = /** @type {(inputs: Wrapped_Share_VolumeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.volumeText} levantados en la semana del ${i?.range}. My Pocket Gym.`)
};

const pt_pt2_wrapped_share_volume = /** @type {(inputs: Wrapped_Share_VolumeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.volumeText} levantados na semana de ${i?.range}. My Pocket Gym.`)
};

const fr_fr2_wrapped_share_volume = /** @type {(inputs: Wrapped_Share_VolumeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`J'ai soulevé ${i?.volumeText} la semaine du ${i?.range}. My Pocket Gym.`)
};

const de_de2_wrapped_share_volume = /** @type {(inputs: Wrapped_Share_VolumeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.volumeText} bewegt in der Woche vom ${i?.range}. My Pocket Gym.`)
};

const it_it2_wrapped_share_volume = /** @type {(inputs: Wrapped_Share_VolumeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.volumeText} sollevati nella settimana del ${i?.range}. My Pocket Gym.`)
};

/**
* | output |
* | --- |
* | "{volumeText} lifted in the week of {range}. My Pocket Gym." |
*
* @param {Wrapped_Share_VolumeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_share_volume = /** @type {((inputs: Wrapped_Share_VolumeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Share_VolumeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_share_volume(inputs)
	if (locale === "es-419") return es_419_wrapped_share_volume(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_share_volume(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_share_volume(inputs)
	if (locale === "de-DE") return de_de2_wrapped_share_volume(inputs)
	if (locale === "it-IT") return it_it2_wrapped_share_volume(inputs)
	return en_us2_wrapped_share_volume(inputs)
});
export { wrapped_share_volume as "wrapped.share_volume" }